import React, { Component } from 'react';
import "../css/home.css"
import APP_IMAGE from "../assets/reanime-in-app.png"
import PLAYSTORE_IMAGE from "../assets/google-play-badge.png"
import LOGO from "../assets/reanime-circle-name-image-subtitle-transparent-dark-compressed.png"

class Home extends Component {

    render() { 
        const Logo = <div id="home-header">
            <img src={LOGO} alt="Logo"/>
        </div>


        return ( 
            <main id="body">
                {/* <div id="background"></div> */}
                <section>
                    <div id="body-one">
                        {/* {Logo} */}
                        <h1 id="description">Re:anime has been taken down, please uninstall the app.</h1>
                        {/* <a href="https://play.google.com/store/apps/details?id=com.joshuajosephmyers.reanime" >
                            <img id="playstore-img" src={PLAYSTORE_IMAGE} alt="Download Reanime on playstore"/>
                        </a> */}
                    </div>
                    {/* <div id="body-two">
                        <img id="mobile-img" src={APP_IMAGE} alt="Re:Anime app image"/>
                    </div> */}
                </section>
            </main>
        );
    }
}
 
export default Home;